/**
 * Typed Vuex Store Composable
 * 
 * Provides a typed wrapper around Vuex store for use in Composition API components.
 * 
 * @example
 * ```typescript
 * import { useStore } from '@/composables/core/useStore';
 * 
 * export default defineComponent({
 *   setup() {
 *     const store = useStore();
 *     const userId = computed(() => store.getters.userId);
 *     
 *     return { userId };
 *   }
 * });
 * ```
 */

import { useStore as baseUseStore } from 'vuex';

export function useStore() {
  return baseUseStore();
}

